import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const ArtisticTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={containerClass}>
       {/* Background Blurs */}
       <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-200 rounded-full mix-blend-multiply filter blur-[80px] opacity-40 animate-blob"></div>
       <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-warning-200 rounded-full mix-blend-multiply filter blur-[80px] opacity-40 animate-blob animation-delay-2000"></div>
       <div className="absolute -bottom-32 left-20 w-[500px] h-[500px] bg-pink-200 rounded-full mix-blend-multiply filter blur-[80px] opacity-40 animate-blob animation-delay-4000"></div>

       <div className="relative z-10 p-16 flex flex-col h-full bg-white/50 backdrop-blur-sm">
           {!hideHeader && (
             <>
               <div className="text-center mb-16">
                   <div className="inline-block p-4 bg-white shadow-xl rounded-full mb-6">
                       <LogoImage size="md" />
                   </div>
                   <h1 className="text-3xl font-bold text-neutral-800 tracking-tight">{profile.name}</h1>
                   <div className="w-16 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto my-4 rounded-full"></div>
                   <p className="text-neutral-500">{type} / {title}</p>
               </div>

               <div className="bg-white/80 p-8 rounded-2xl shadow-sm border border-white mb-8 flex justify-between items-center">
                   <div>
                       <p className="text-xs font-bold text-neutral-400 uppercase tracking-widest mb-2">Billed To</p>
                       {client ? (
                           <div>
                               <p className="font-bold text-lg text-neutral-900">{client.name}</p>
                               <p className="text-neutral-500">{client.company}</p>
                           </div>
                       ) : <span className="text-neutral-300">No Client</span>}
                   </div>
                   <div className="text-right space-y-2">
                       {metaData.map((m, i) => (
                           <div key={i} className="flex items-center justify-end gap-3">
                               <span className="text-xs font-bold text-neutral-400 uppercase">{m.label}</span>
                               <span className="font-medium bg-neutral-100 px-3 py-1 rounded-full text-xs">{m.value}</span>
                           </div>
                       ))}
                   </div>
               </div>
             </>
           )}

           <div className="flex-1 artistic-table">
               {children}
           </div>

           <div className="mt-auto text-center">
               <p className="text-neutral-400 text-sm font-medium">{footerNote}</p>
           </div>
       </div>
    </div>
  );
};

export default ArtisticTemplate;